import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import { type IEquipmentByFault, type IEquipmentByFaultKeys } from '../model/equipmentByFault';

const equipmentByFaultKey = (
  keys: IEquipmentByFaultKeys,
): [string, number, Array<number>, ITableSorting, string, Date, Date] => [
  'equipmentByFault',
  keys.faultId,
  keys.locationIds,
  keys.sorting,
  keys.statusType,
  keys.dateFrom,
  keys.dateTo,
];

const equipmentByFaultFn = ({ queryKey }: QueryFunctionContext<ReturnType<typeof equipmentByFaultKey>>) => {
  const orderBy = queryKey[3].id ? queryKey[3].id : undefined;
  const direction = !queryKey[3].id ? undefined : queryKey[3].desc ? 'desc' : 'asc';

  const params = {
    fault_id: queryKey[1],
    location_ids: queryKey[2],
    sort: {
      field: orderBy,
      direction: direction,
    },
    status_type: queryKey[4] === 'all' ? undefined : queryKey[4],
    date_from: queryKey[5],
    date_to: queryKey[6],
  };

  return apiClient.get<{ data: IEquipmentByFault[] }>(
    `${APP_API_URL_V2}fsd/action-item/failure-cause-categories/equipment-by-fault`,
    {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    },
  );
};

const equipmentByFaultSelect = ({ data }: AxiosResponse<{ data: IEquipmentByFault[] }>) => {
  if (!data.data) {
    return [];
  }
  return data.data;
};

export const useEquipmentByFaultQuery = (keys: IEquipmentByFaultKeys) => {
  return useQuery({
    queryKey: equipmentByFaultKey(keys),
    queryFn: equipmentByFaultFn,
    enabled: keys.enabled,
    select: equipmentByFaultSelect,
  });
};
